"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseToSubscribeState = void 0;
var SubscribeState_1 = require("@/pages/common/states/SubscribeState");
exports.responseToSubscribeState = function (response) {
    var data = response.data;
    if (!data.isSuccess && !data.isDuplicated && !data.isPending)
        return SubscribeState_1.SubscribeState.UNKNOWN;
    if (!data.isSuccess && data.isDuplicated)
        return SubscribeState_1.SubscribeState.DUPLICATED;
    if (data.isPending)
        return SubscribeState_1.SubscribeState.UNCONFIRM;
    return SubscribeState_1.SubscribeState.SUCCESS;
};
